const STAGE_LABELS: Record<string, string> = {
  pending: 'Queued',
  in_progress: 'In progress',
  received: 'Pulled',
  preparing: 'Crafting',
  ready: 'On bar',
  completed: 'Served',
  cancelled: 'Cancelled',
  active: 'Active',
};

export function orderStatusKey(status: string | null | undefined): string {
  return String(status || '').toLowerCase().trim();
}

export function getStatusLabel(status: string | null | undefined): string {
  const key = orderStatusKey(status);
  return STAGE_LABELS[key] || status || '';
}

export function inferCancelledFromStatus(order: {
  status?: string | null;
  cancelled_from_status?: string | null;
  ready_at?: string | null;
}): string | null {
  if (orderStatusKey(order.status) !== 'cancelled') return null;
  const stored = orderStatusKey(order.cancelled_from_status);
  if (stored && stored !== 'cancelled') return stored;
  if (order.ready_at) return 'ready';
  return null;
}

export function getOrderStatusDisplay(order: {
  status?: string | null;
  cancelled_from_status?: string | null;
  ready_at?: string | null;
}): { label: string; stageKey: string | null; stageLabel: string | null; fullLabel: string } {
  const label = getStatusLabel(order.status);
  const stageKey = inferCancelledFromStatus(order);
  const stageLabel = stageKey ? getStatusLabel(stageKey) : null;
  return {
    label,
    stageKey,
    stageLabel,
    fullLabel: stageLabel ? `${label} · ${stageLabel}` : label,
  };
}
